<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
             <a-form-item prop="categoryId">
                <span slot="label" ><a-tooltip>{{ $t('小组分类') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.categoryId" :maxLength="32" :placeholder="$t('请输入')+'小组分类'" allow-clear @pressEnter="handleQuery"/>
             </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="groupName">
                <span slot="label" ><a-tooltip>{{ $t('小组名称') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.groupName" :maxLength="32" :placeholder="$t('请输入')+'小组名称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item prop="isRecommend">
                  <span slot="label" ><a-tooltip>{{ $t('是否推荐') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.isRecommend" :maxLength="32" :placeholder="$t('请输入')+'是否推荐'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="isOfficial">
                  <span slot="label" ><a-tooltip>{{ $t('是否官方小组：1-是，0-否') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.isOfficial" :maxLength="32" :placeholder="$t('请输入')+'是否官方小组：1-是，0-否'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createBeginTime"
                    :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createEndTime"
                    :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['community:communitygroup:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['community:communitygroup:edit']">
          <a-icon type="edit" />{{ $t('修改') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['community:communitygroup:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['community:communitygroup:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 2910 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
       <span slot="createTime" slot-scope="text, record">
         {{ parseTime(record.createTime) }}
       </span>
<span slot="joinType" slot-scope="text, record">
          <span v-if="record.joinType == 10">{{ $t('自由加入') }}</span>
          <span v-else-if="record.joinType == 20">{{ $t('审核加入') }}</span>
          <span v-else-if="record.joinType == 30">{{ $t('仅邀请加入') }}</span>
          <span v-else>{{ record.joinType }}</span>
        </span>

<span slot="groupStatus" slot-scope="text, record">
        
          <span v-if="record.groupStatus == 1010">{{ $t('正常') }}</span>
          <span v-else-if="record.groupStatus == 1020">{{ $t('待审核') }}</span>
          <span v-else-if="record.groupStatus == 1030">{{ $t('审核拒绝') }}</span>
          <span v-else-if="record.groupStatus == 1040">{{ $t('已禁用') }}</span>
          <span v-else>{{ record.groupStatus }}</span>
        </span>
        <span slot="categoryId" slot-scope="text, record">
          {{ categoryDict[record.categoryId] || record.categoryId }}
        </span>
        <span slot="isRecommend" slot-scope="text, record">
          <span v-if="record.isRecommend">{{ $t("是") }}</span>
          <span v-else>{{ $t("否") }}</span>
        </span>
        <span slot="isOfficial" slot-scope="text, record">
          <span v-if="record.isOfficial">{{ $t("是") }}</span>
          <span v-else>{{ $t("否") }}</span>
        </span>
        <span slot="isMute" slot-scope="text, record">
          <span v-if="record.isMute">{{ $t("是") }}</span>
          <span v-else>{{ $t("否") }}</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['community:communitygroup:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['community:communitygroup:edit']">
            <a-icon type="edit" />{{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communitygroup:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['community:communitygroup:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      
        <span slot="groupAvatar" slot-scope="text, record">
          <div>
            <img v-if="record.groupAvatar" :src="record.groupAvatar" style="width:60px;height:60px;border-radius:4px;object-fit:cover;" alt="none"/>
          </div>
        </span>
      
        <span slot="groupCover" slot-scope="text, record">
          <div>
            <img v-if="record.groupCover" :src="record.groupCover" style="width:60px;height:60px;border-radius:4px;object-fit:cover;" alt="none"/>
          </div>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityGroup, listCommunityGroup, delCommunityGroup } from '@/api/community/communityGroup/communityGroup'
import { listCommunityGroupCategory } from '@/api/community/communityGroup/communityGroupCategory'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityGroup',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 分类字典 {id: categoryName}
      categoryDict: {},
      // 查询参数
      queryParam: {
        categoryId: undefined,
        groupName: undefined,
        joinType: undefined,
        isRecommend: undefined,
        isOfficial: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('小组分类'),
          dataIndex: 'categoryId',
          width: 80,
          scopedSlots: { customRender: 'categoryId' },
          align: 'center'
        },
        {
          title: this.$t('组长用户'),
          dataIndex: 'ownerId',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('小组名称'),
          dataIndex: 'groupName',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('小组头像URL'),
          dataIndex: 'groupAvatar',
          width: 200,
          align: 'center',
        scopedSlots: { customRender: 'groupAvatar' },
        },
        {
          title: this.$t('小组封面URL'),
          dataIndex: 'groupCover',
          width: 200,
          align: 'center',
        scopedSlots: { customRender: 'groupCover' },
        },
        {
          title: this.$t('小组简介摘要'),
          dataIndex: 'summary',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('加入方式'),
          dataIndex: 'joinType',
          width: 100,
          scopedSlots: { customRender: 'joinType' },
          align: 'center'
        },
        {
         title: this.$t('小组状态'), 
         dataIndex: 'groupStatus', 
          width: 100,
          scopedSlots: { customRender: 'groupStatus' }, 
         align: 'center' 
        },
        {
          title: this.$t('成员数量'),
          dataIndex: 'memberNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('帖子数量'),
          dataIndex: 'postNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('活动数量'),
          dataIndex: 'activityNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('是否推荐'),
          dataIndex: 'isRecommend',
          width: 100,
          scopedSlots: { customRender: 'isRecommend' },
          align: 'center'
        },
        {
          title: this.$t('是否官方'),
          dataIndex: 'isOfficial',
          width: 100,
          scopedSlots: { customRender: 'isOfficial' },
          align: 'center'
        },
        {
          title: this.$t('是否全员禁言'),
          dataIndex: 'isMute',
          width: 100,
          scopedSlots: { customRender: 'isMute' },
          align: 'center'
        },
        {
          title: this.$t('审核原因'),
          dataIndex: 'auditReason',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('排序值'),
          dataIndex: 'sort',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width: 160,
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.initCategoryDict()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询社区小组列表 */
    getList () {
      this.loading = true
     pageCommunityGroup(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 初始化分类字典 */
    initCategoryDict () {
      listCommunityGroupCategory({}).then(response => {
        const list = response.data || []
        const dict = {}
        list.forEach(item => {
          dict[item.id] = item.categoryName
        })
        this.categoryDict = dict
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        categoryId: undefined,
        groupName: undefined,
        joinType: undefined,
        isRecommend: undefined,
        isOfficial: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      const reqData = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityGroup(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message, 3)
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/community/community/group/export',
            that.queryParam
          , `社区小组_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
   }
 }
}
</script>
